import Phaser from "phaser";
export default class GameOver extends Phaser.Scene{
    constructor() {
        super('game-over-scene')
    }
    init(data) {
        this.score = data.score
        this.power = data.power
        this.totalPower = data.power*100
        this.life = data.life
        this.totalLife = data.life*10
        this.graze = data.graze
        this.totalGraze = this.score + this.totalPower + this.totalLife
        this.endScore = this.totalGraze*this.graze
        this.replayButton = undefined
    }
    preload() {
        this.load.image('Background3', 'images/score-bg.png')
        this.load.image('Back-btn', 'images/back-btn.png')
    }
    create() {
        this.halfWidth = this.scale.width*0.5
        this.halfHeight = this.scale.height*0.5
        this.add.image(this.halfWidth, this.halfHeight, 'Background3').setScale(5)

        this.add.text(50, 100, 'Total Score', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(80, 160, 'Score point', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(80, 220, 'Life point', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(80, 280, 'Power point', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(80, 340, '----------------------------------------------'
        , {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(80, 400, 'Graze point', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})

        this.add.text(400, 160, '=', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(400, 220, '=', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(400, 280, '=', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(400, 400, '=', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(400, 460, '=', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})

        this.add.text(440, 160, this.score, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(440, 220, this.life, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(440, 280, this.power, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(440, 400, this.totalGraze, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})

        this.add.text(750, 220, '*10', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(750, 280, '*100', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(750, 400, '*', {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        this.add.text(775, 400, this.graze, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})

        if (this.graze == 0) {
            this.add.text(440, 460, this.totalGraze, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        }
        else {
            this.add.text(440, 460, this.endScore, {fontSize: '40px', fill: '#FFFFFF', fontStyle: 'bold'})
        }
        this.replayButton = this.add.image(100, 900, 'Back-btn')
        .setInteractive()
        .setScale(3)
        this.replayButton.once('pointerup', () => {
            this.scene.start('home-screen-scene')
        })
    }
}